import { render, staticRenderFns } from "./AzLiveList.vue?vue&type=template&id=e704ea60"
import script from "./AzLiveList.vue?vue&type=script&lang=js"
export * from "./AzLiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports